import React from 'react';
interface Company {
  id: number;
  name: string;
  logo: string;
  accountType: string;
  sequenceStage: string;
  revenue: string;
  propensityScore: number;
  propensityColor: 'green' | 'orange' | 'red';
  trafficVisits: number;
}
interface CompanyRowProps {
  company: Company;
}
export function CompanyRow({
  company
}: CompanyRowProps) {
  const getPropensityColorClass = (color: string) => {
    switch (color) {
      case 'green':
        return 'bg-green-500 shadow-green-200';
      case 'orange':
        return 'bg-orange-400 shadow-orange-200';
      case 'red':
        return 'bg-red-500 shadow-red-200';
      default:
        return 'bg-gray-400 shadow-gray-200';
    }
  };
  const getPropensityTextColor = (color: string) => {
    switch (color) {
      case 'green':
        return 'text-green-700';
      case 'orange':
        return 'text-orange-700';
      case 'red':
        return 'text-red-700';
      default:
        return 'text-gray-700';
    }
  };
  return <tr className="hover:bg-gradient-to-r hover:from-gray-50 hover:to-transparent transition-all duration-200 group cursor-pointer" data-id="element-808">
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-809">
        <div className="flex items-center gap-3" data-id="element-810">
          <div className="w-8 h-8 flex items-center justify-center text-2xl transform group-hover:scale-110 transition-transform duration-200" data-id="element-811">
            {company.logo}
          </div>
          <span className="text-sm font-medium text-gray-900 group-hover:text-red-600 transition-colors duration-200" data-id="element-812">
            {company.name}
          </span>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-813">
        <span className="text-sm text-gray-700" data-id="element-814">{company.accountType}</span>
      </td>
      <td className="px-6 py-4" data-id="element-815">
        <span className="text-sm text-gray-700" data-id="element-816">{company.sequenceStage}</span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-817">
        <span className="text-sm text-gray-700 font-medium" data-id="element-818">
          {company.revenue}
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-819">
        <div className="flex items-center gap-2" data-id="element-820">
          <div className={`w-2.5 h-2.5 rounded-full ${getPropensityColorClass(company.propensityColor)} shadow-md animate-pulse`} data-id="element-821" />
          <span className={`text-sm font-semibold ${getPropensityTextColor(company.propensityColor)}`} data-id="element-822">
            {company.propensityScore}
          </span>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap" data-id="element-823">
        <span className="text-sm text-gray-700 font-medium" data-id="element-824">
          {company.trafficVisits.toLocaleString()}
        </span>
      </td>
    </tr>;
}